import React from 'react';
import './input-search.scss';
import { SearchIcon } from 'components';

export function InputSearch({ placeholder, getSearch, reset }) {

  const changeSearch = (event)=> {
    getSearch(event.target.value);
    reset();
  }

  return (
    <nav className="navbar navbar-light">
      <form className="form-inline">
        <input onChange={changeSearch} className="form-control mr-sm-2" placeholder={placeholder} aria-label="Search" />
        <button className="input-search btn my-2 my-sm-0 position-absolute" type="submit"> <SearchIcon /> </button>
      </form>
    </nav>
  );
}
